import axios from 'axios';

/**
 * 获取组网
 */
export const getCluster = (params) => {
  return axios.get(`/api/clusters/${params.clusterId}`);
};


/**
 * 获取组网列表
 */
export const getClusters = ({ projectId }) => {
  return axios.get('/api/clusters', {
    params: { projectId },
  });
};


/**
 * 创建组网
 */
export const postClusters = (params) => {
  return axios.post('/api/clusters', params);
};


/**
 * 更新组网属性
 */
export const updateCluster = (clusterForm) => {
  const { clusterId } = clusterForm;
  delete clusterForm.clusterId;
  return axios.patch(`/api/clusters/${clusterId}`, clusterForm);
};


/**
 * 删除组网
 */
export const deleteCluster = (params) => {
  return axios.delete(`/api/clusters/${params.clusterId}`);
};

